import React from 'react';
import { StyledModal, TitleWrapper, ColoredButton, FooterWrapper, BodyWrapper } from './styled';
import { Mutation } from 'react-apollo';
import agentCreateCod from './graphql/mutation/agentCreateCOD';

const ConfirmPayCodModal = props => {
  const confirmStatus = agentCreateCodMutation => {
    let ids = [];
    let documents = [];

    ids = props.selectedList.map(data => data._id);
    documents = props.document.map(data => data);

    const createCod = {
      _id: ids,
      document: documents,
      cod_in_date: props.cod_in_date,
    };

    console.log('createCod', createCod);

    agentCreateCodMutation({
      variables: {
        create: createCod,
      },
    });
  };

  return (
    <Mutation
      mutation={agentCreateCod}
      update={() => {
        props.close();
        props.closeAll();
      }}
      onError={error => {
        console.log(error);
      }}
      refetchQueries={() => ['shipmentKA']}
    >
      {agentCreateCodMutation => {
        return (
          <StyledModal
            show={props.show}
            labelButtonCancel="ยกเลิก"
            labelButtonConfirm="ใช่, ยืนยัน"
          >
            <TitleWrapper>
              <b style={{ fontSize: '18px' }}>แจ้งเตือน</b>
            </TitleWrapper>
            <BodyWrapper>
              <b>ยืนยันการชำระเงินค่า COD ใช่หรือไม่ ?</b>
              <span>
                * หากส่งแล้วจะถือว่าท่านได้ทำการ <b>“ยืนยัน”</b>{' '}
                ความถูกต้องของข้อมูลชุดนี้แล้วจะไม่สามารถแก้ไขได้อีก
              </span>
            </BodyWrapper>
            <FooterWrapper>
              <ColoredButton
                bgColor="#fff"
                color="#000"
                onClick={() => {
                  props.close();
                }}
              >
                <i className="fas fa-times"></i>
                ยกเลิก
              </ColoredButton>
              <ColoredButton onClick={() => confirmStatus(agentCreateCodMutation)}>
                ใช่, ฉันยืนยัน
              </ColoredButton>
            </FooterWrapper>
          </StyledModal>
        );
      }}
    </Mutation>
  );
};

export default ConfirmPayCodModal;
